import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./product.css";
import { TiMinus, TiPlus } from "react-icons/ti";
import { BlogsSlider } from "../Slider/BlogsSlider";
import Offers from "./Offers";
import { Link } from "react-scroll";
const offers = [
  {
    title: "1UP MultiManager FoF",
    text: "Cut through the clutter of 1,500+ mutual fund schemes with Ladderup’s data-driven PMS strategy.",
    link: "/multimanager-portfolio",
  },
  {
    title: "Credit Opportunities",
    text: "Enhance your fixed income returns without stretching the risk curve.",
    link: "/opportunities-portfolio",
  },
  {
    title: "Proud Portfolio",
    text: "Own high-quality businesses with the potential to create enduring wealth.",
    link: "/proud-portfolio",
  },
];

const projectInfo = [
  {
    title: "Investment Strategies",
    text: "1UP MultiManager Portfolio",
    service: "Services 1",
    data: [
      {
        title: "The Problem",
        text: "India’s mutual fund market is ever-expanding and may confuse investors. Also, with over 1,500 schemes across 44 AMCs, investors often rely on past performance or popular choices—a strategy that fails to predict future winners or protect capital during downturns.",
      },
      {
        title: "The Solution",
        text: "1UP MultiManager Portfolio is Ladderup’s proprietary Fund of Funds PMS—a strategy that focuses on fund managers, not just funds, and uses predictive analytics to capture consistent outperformance.",
      },
      {
        title: "Why It Works",
        text: `
          • Multi-Asset Spread: Equity, sectoral, global, and ETFs.
          • Manager-Focused Selection: Based on behaviour and consistency.
          • Tactical Sector Moves: Guided by real-time research.
          • Dynamic Rebalancing: Adapts to changing markets.
          • Risk-Off Flexibility: Shifts to cash during stress.
        `,
      },
      {
        title: "Why Do You Need This In Your Portfolio?",
        text: `
          • You want mutual fund exposure backed by deep research and active oversight.
          • You prefer a forward-looking approach that goes beyond static ratings.
          • You value lower drawdowns and smarter entry/exit decisions.
          • Ideal for HNIs who want a professionalised, PMS-level solution in the MF space.
        `,
      },
    ],
  },
  {
    title: "Investment Strategies",
    text: "Credit Opportunities Portfolio",
    service: "Services 2",
    data: [
      {
        title: "The Problem",
        text: "Traditional debt investments offer limited upside, while higher yields often come with hidden credit or liquidity risks. Balancing this trade-off without the right filters can lead to capital erosion or suboptimal returns.",
      },
      {
        title: "The Solution",
        text: "Credit Opportunities Portfolio is Ladderup’s fixed income PMS designed to deliver superior yield with disciplined risk management. By actively managing a diversified mix of credit instruments, it brings institutional-quality debt investing to HNIs.",
      },
      {
        title: "Why It Works",
        text: `
          • 100+ Factor Filter: Governance, scalability, cash flows, valuation & more.
          • Stock-First Approach: Sector-agnostic, conviction-led picks.
          • Proven Case Backing: Indian Hotels, CAMS, and other long-term winners.
          • Staggered Entry: Thoughtful, phased capital deployment.
          • Disciplined Holding: Strategic cash calls, not blind allocation.
        `,
      },
      {
        title: "Why Do You Need This In Your Portfolio?",
        text: `
          • You want to own fewer, better businesses—not just ride market cycles.
          • You value compounding, capital efficiency, and margin of safety.
          • You seek a legacy portfolio that grows across generations.
          • Designed for investors with a long-term mindset and low portfolio churn tolerance.
        `,
      },
    ],
  },
  {
    title: "Investment Strategies",
    text: "Portfolio Management",
    service: "Services 3",
    data: [
      {
        title: "The Problem",
        text: "Equity investing is often driven by noise, trends, or sectoral rotation. This results in fragmented portfolios with no clear strategy or conviction. True wealth creation requires identifying businesses—not just stocks—that compound value over decades.",
      },
      {
        title: "The Solution",
        text: "Proud Portfolio is Ladderup’s equity PMS that curates a concentrated basket of long-term compounders, selected through a robust qualitative and quantitative framework.",
      },
      {
        title: "Why It Works",
        text: `
          • 100+ Factor Filter: Governance, scalability, cash flows, valuation & more.
          • Stock-First Approach: Sector-agnostic, conviction-led picks.
          • Proven Case Backing: Indian Hotels, CAMS, and other long-term winners.
          • Staggered Entry: Thoughtful, phased capital deployment.
          • Disciplined Holding: Strategic cash calls, not blind allocation.
        `,
      },
      {
        title: "Why Do You Need This In Your Portfolio?",
        text: `
          • You want to own fewer, better businesses—not just ride market cycles.
          • You value compounding, capital efficiency, and margin of safety.
          • You seek a legacy portfolio that grows across generations.
          • Designed for investors with a long-term mindset and low portfolio churn tolerance.
        `,
      },
    ],
  },
];
const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const foreSteps = [
  {
    title: "Insight-Led, Risk-Aware Strategy ",
    text: "Dolor Sit Amet",
    dis: "Every decision is driven by deep market insight, disciplined research, and a strong risk management framework — ensuring smarter choices and more resilient outcomes.",
    points: [
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
    ],
    url: "",
  },
  {
    title: "Bespoke Approach",
    text: "Dolor Sit Amet",
    dis: "Every strategy is thoughtfully designed to align with your distinct goals, risk appetite, and financial journey.",
    points: [
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
    ],
    url: "",
  },
  {
    title: "Sustainable Wealth Creation",
    text: "Dolor Sit Amet",
    dis: "Focused on long-term value through disciplined investing and forward-looking insights.",
    points: [
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
    ],
    url: "",
  },
  {
    title: "Performance-Driven Products",
    text: "Dolor Sit Amet",
    dis: "Proprietary offerings like 1UP, Credit Opportunities, and Proud Portfolio — built to grow, built to perform.",
    points: [
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
      "Lorem Ipsum Aolor Ait Amet",
    ],
    url: "",
  },
];

const Product = () => {
  const pathRef = useRef(null);
  const heroRef = useRef(null);
  const [steps, setSteps] = useState();
  const [activeIndex, setActiveIndex] = useState(null);
  const [stepsFilter, setStepsFilter] = useState(foreSteps?.[0]?.title);

  useEffect(() => {
    setSteps(foreSteps?.find?.((el) => el?.title === stepsFilter));
  }, [stepsFilter]);
  const toggleCollapse = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    const pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    const animatePath = () => {
      path.style.transition = "stroke-dashoffset 5s ease-in-out";
      path.style.strokeDashoffset = "0";

      setTimeout(() => {
        // Reset animation
        path.style.transition = "none";
        path.style.strokeDashoffset = pathLength;

        // Small delay before restarting
        setTimeout(() => {
          path.style.transition = "stroke-dashoffset 5s ease-in-out";
          path.style.strokeDashoffset = "0";
        }, 100);
      }, 5000);
    };

    // Run animation loop continuously, regardless of visibility
    const interval = setInterval(animatePath, 7000); // 5s animation + 3s delay

    animatePath(); // Start immediately

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    const heroBg = document.querySelector(".heroBg");
    const herotext = document.querySelector(".heroText");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          heroBg.classList.add("active");
          setTimeout(() => {
            herotext.classList.add("active");
          }, 1000);
        } else {
          herotext.classList.remove("active");
          setTimeout(() => {
            heroBg.classList.remove("active");
          }, 500);
        }
      },
      { rootMargin: "0px", threshold: 0.5 }
    );

    // Store the current reference in a variable
    const currentHeroRef = heroRef.current;

    if (currentHeroRef) {
      observer.observe(currentHeroRef);
    }

    return () => {
      if (currentHeroRef) {
        observer.unobserve(currentHeroRef);
      }
    };
  }, [heroRef]);

  return (
    <div>
      <div className="row m-0 p-0 pageBg">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div class="col-11 text-start" data-aos="zoom-in-up">
            <p class="fs-5">Our Offering Us</p>
            <p class="fs-1">Designed for Growth, </p>
            <p class="fs-1 org  line-height-1 mb-2"> Driven by Insight</p>
            <p class="tJustify">
              Our products offer proprietary, data-driven investment strategies,
              underpinned by robust risk management and sustained growth through
              active oversight.{" "}
            </p>

            <button className="buttonEffect mb-2">Know More </button>
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-end justify-content-end">
          <div class="col-md-10 col-12">
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="auto"
              viewBox="0 0 869 832"
              fill="none"
              class="mt-4"
            >
              <path
                ref={pathRef}
                id="myPath"
                d="M35.5 832V627.5H232V427H446.5V233H651.5V35H868.5"
                stroke="#F47024"
                strokeWidth="70"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="productHero" ref={heroRef}>
        <div class="heroBg"></div>
        <div class="heroText">
          <div class="col-lg-7 col-11">
            <p class="fs-5">Wealth management</p>
            <p class="fs-1">Personalized</p>
            <p class="fs-1 fw-bold org">Wealth Solution For long-term growth</p>
            <p class="fs-5">
              At LadderUp, we are committed to empowering individuals and
              businesses with comprehensive wealth management and investment
              solutions. Our expert-driven strategies ensure financial growth,
              stability, and long-term prosperity.
            </p>
            <br />
          </div>
        </div>
      </div>

      <div>
        <div class="col-11 m-auto mt-5">
          <p>Our Offering</p>
          <p class="fs-1">
            Investment <span class="fw-semibold org">Strategy</span>
          </p>
          <div class="offerMobile">
            <div class="row mt-4 h-100">
              <div class="col-lg-4 col-md-6 mt-4">
                <div class="col-11 m-auto text-start p-3 investCart">
                  <p class="fs-3 fw-semibold">
                    Growth Maximizer – Unlock High-Value Opportunities
                  </p>
                  <div class="my-5">
                    <br />
                  </div>
                  <p class="fs-5">
                    A dynamic investment approach that focuses on high-growth
                    sectors, capitalizing on emerging market trends to maximize
                    returns.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-4">
                <div class="col-11 m-auto text-start p-3 investCart">
                  <p class="fs-3 fw-semibold">
                    Stability Plus – Balance Risk and Reward
                  </p>
                  <div class="my-5">
                    <br />
                  </div>
                  <p class="fs-5">
                    A dynamic investment approach that focuses on high-growth
                    sectors, capitalizing on emerging market trends to maximize
                    returns.
                  </p>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mt-4">
                <div class="col-11 m-auto text-start p-3 investCart">
                  <p class="fs-3 fw-semibold">
                    Growth Maximizer – Unlock High-Value Opportunities
                  </p>
                  <div class="my-5">
                    <br />
                  </div>
                  <p class="fs-5">
                    A dynamic investment approach that focuses on high-growth
                    sectors, capitalizing on emerging market trends to maximize
                    returns.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="offerPc">
            <Offers offers={offers} />
          </div>
        </div>
      </div>
      <div className="mt-3" style={{ background: "#fef8f4" }}>
        <br />
        <div className="col-11 m-auto">
          {projectInfo.map((el, i) => {
            return (
              <div
                key={i}
                className="border-bottom"
                data-bs-toggle="collapse"
                href={`#projectInfo${i}`}
                role="button"
                aria-expanded={activeIndex === i}
                aria-controls={`projectInfo${i}`}
                onClick={() => toggleCollapse(i)}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="text-start">
                    <p className="mt-2">{el.title}</p>
                    <p className="fs-2 fw-bold org">{el.text}</p>
                    <p className="fs-1 line-height-1">{el.service}</p>
                  </div>
                  <div>
                    <div
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        color: "#f47024",
                        border: "2px solid #f47024",
                      }}
                    >
                      {activeIndex === i ? <TiMinus /> : <TiPlus />}
                    </div>
                  </div>
                </div>
                <div className="collapse" id={`projectInfo${i}`}>
                  <div className="card card-body border-0">
                    {el.data.map((item, idx) => {
                      return (
                        <div
                          key={idx}
                          className="bg-white mt-4 text-start p-3"
                          style={{ border: "2px solid #f47024" }}
                        >
                          {item.img && (
                            <img
                              src={item.img}
                              style={{ width: "100px" }}
                              alt=""
                              loading="lazy" // 👈 yeh important hai
                            />
                          )}
                          <p className="fs-3 org">{item.title}</p>
                          <p>{item.text}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <br />
      </div>
      <div class="col-11 m-auto mt-4">
        {/* <p class="fs-5 line-height-1" data-aos="fade-up">
          Why Choose Ladderup?
        </p> */}
        <p class="fs-1 fw-bold" data-aos="fade-up">
          Because true wealth is built with{" "}
          <span class="org">insight, intention, and impact.</span>
        </p>
        <div class="row">
          <div class="col-lg-5 ">
            <div class="col-11 m-auto row">
              {foreSteps?.map((step, i) => {
                return (
                  <div class="col-sm-6 mt-4" data-aos="fade-up">
                    <Link
                      activeClass="active"
                      to="points"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      style={{ textDecoration: "none" }}
                      onClick={() => setStepsFilter(step?.title)}
                    >
                      <div
                        class="p-3  d-flex align-items-end justify-content-center"
                        style={
                          stepsFilter === step?.title
                            ? {
                                background: "#F47024",
                                color: "white",
                                cursor: "pointer",
                                aspectRatio: "1/1",
                              }
                            : {
                                background: "rgba(244,112,36,0.1)",
                                cursor: "pointer",
                                color: "black",
                                aspectRatio: "1/1",
                              }
                        }
                      >
                        <div class="my-3 text-start">
                          <img
                            src={require("../../Images/graf.png")}
                            style={{ width: "30px" }}
                            alt=""
                            loading="lazy" // 👈 yeh important hai
                          />
                          <p class="fs-5">{step?.title}</p>
                          {/* <p class='fs-5 fw-bold'>{step?.text}</p> */}
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
          <div class="col-lg-7">
            <div class=" text-start points">
              <p class="fs-1 fw-bold mt-3" data-aos="fade-up">
                {steps?.title}
                {/* <span class='fw-bold org'>{steps?.text}</span>  */}
              </p>
              <p class="fs-5 tJustify" data-aos="fade-up">
                {steps?.dis}
              </p>
              {/* <div class='mt-2'>
                                {
                                    steps?.points?.map((point, i) => {
                                        return (
                                            <div class='border-bottom d-flex gap-2 fs-5 py-2' data-aos="fade-up">
                                                <img src={require('../../Images/graf.png')} style={{ width: '30px' }} alt="" />
                                                <p>{point}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div> */}
              <button className="buttonEffect" data-aos="fade-up">
                Know More{" "}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <WhyChose /> */}
      <div class="mt-4">
        <div class="col-11 m-auto text-start ">
          <p class="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p class="fs-1 fw-semibold" data-aos="fade-up">
            The latest from{" "}
          </p>
          <p class="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default Product;
